<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-18">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/ChapterOne#Anchor-1">Chapter One</a></p>
<p class="TOCitem"><a href="#/ChapterTwo#Anchor-1">Chapter Two</a></p>
<p class="TOCitem"><span href="#/ChapterThree#Anchor-1" title="Link target outside of Sample">Chapter Three</span></p>
<p class="TOCitem"><span href="#/ChapterFour#Anchor-1" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/ChapterFive#Anchor-1" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/ChapterSix#Anchor-1" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/ChapterSeven#Anchor-1" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/ChapterEight#Anchor-1" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/ChapterNine#Anchor-1" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/ChapterTen#Anchor-1" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/ChapterEleven#Anchor-1" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOCitem"><span href="#/ChapterTwelve#Anchor-1" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="TOCitem"><span href="#/ChapterThirteen#Anchor-1" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="TOCitem"><span href="#/ChapterFourteen#Anchor-1" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="TOCitem"><span href="#/ChapterFifteen#Anchor-1" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="TOCitem"><span href="#/ChapterSixteen#Anchor-1" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="TOCitem"><span href="#/Epilogue#Anchor-1" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCitem"><span href="#/DearReader#Anchor-1" title="Link target outside of Sample">Dear Reader</span></p>
<p class="TOCitem"><span href="#/Excerpt#Anchor-1" title="Link target outside of Sample">Excerpt from <em>Gift-Wrapped Family</em> by Lois Richer</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?a4d4578a